import React, { useState } from "react";
import { createContext, useContextSelector } from "@knowt/syncing/utils/use-context-selector";
import { MediaPlayerInstance, useMediaRemote, useMediaStore } from "@vidstack/react";
import { MediaRemoteControl } from "vidstack";

export const MediaPlayerContext = createContext({});

export type MediaPlayerContextProps = {
    mediaPlayerRef: MediaPlayerInstance | null;
    setMediaPlayerRef: any;
    setCurrentTime: React.Dispatch<React.SetStateAction<number>>;
    currentTime: number;
    setEmbeddedMediaCurrentTime: React.Dispatch<React.SetStateAction<number>>;
    remote: MediaRemoteControl;
    seekEmbeddedMedia: (time: number) => any;
    setSeekEmbeddedMedia: React.Dispatch<React.SetStateAction<(number) => any>>;
};

export const MediaPlayerContextProvider = ({ children }: { children: React.ReactNode }) => {
    const [mediaPlayerRef, setMediaPlayerRef] = useState<MediaPlayerInstance | null>(null);
    const [currentTime, setCurrentTime] = useState<number>(0);
    const { currentTime: currentTimeFromPlayer } = useMediaStore({ current: mediaPlayerRef });
    const [seekEmbeddedMedia, setSeekEmbeddedMedia] = useState<number>(0);

    const remote = useMediaRemote(mediaPlayerRef);

    return (
        <MediaPlayerContext.Provider
            value={{
                mediaPlayerRef,
                setMediaPlayerRef,
                currentTime: currentTimeFromPlayer || currentTime,
                setCurrentTime,
                setSeekEmbeddedMedia,
                seekEmbeddedMedia,
                remote,
            }}>
            {children}
        </MediaPlayerContext.Provider>
    );
};

export const useMediaPlayerContextSelector = <T,>(selector: (state: MediaPlayerContextProps) => T) =>
    useContextSelector(MediaPlayerContext, selector);
